import CompanyCommunicationPageForm from './company-communication-form'

export default CompanyCommunicationPageForm;